import { ActionTypes as FaqModalActionTypes } from '../reducers/FaqModal'

export const openModal = flag => async (dispatch, getState) => {
  dispatch({
    type: FaqModalActionTypes.TOGGLE_MODAL,
    isOpen: true
  })
}


export const closeModal = flag => async (dispatch, getState) => {
  dispatch({
    type: FaqModalActionTypes.TOGGLE_MODAL,
    isOpen: false
  })

}



// WEBPACK FOOTER //
// ./src/store/actions/FaqModal.js